<template>
  <div class="content">
    <div>
      <ul class="ul_bar">
        <li
          v-for="item in meanCenterObj._child"
          :key="item.id"
          :style="meanCenterObj.tabName == item.name ? ul_select : ''"
          @click="tabsClick({ parent: meanCenterObj, _child: item })"
        >
          {{ item.title }}
        </li>
      </ul>
      <ul class="select" :style="selectStyle">
        <li v-for="item in options" :key="item.id">{{ item.value }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "tabsCenter",

  data() {
    return {
      options: [
        {
          id: 1,
          value: "选项1",
          label: "黄金糕",
        },
        {
          id: 2,
          value: "选项2",
          label: "双皮奶",
        },
      ],
      value: "",
      ul_select: { color: "#fff", background: "#1680d9" },
    };
  },
  computed: {
    ...mapGetters(["meanCenterObj"]),
    selectStyle() {
      let style =
        this.meanCenterObj.tabName == "cancerP"
          ? { left: " 8.3vw" }
          : this.meanCenterObj.tabName == "cancerDetectionP"
          ? { left: "16.66vw" }
          : { display: "none" };
      return style;
    },
  },
  methods: {
    tabsClick(e) {
      // this.$api.INFO(e.parent.id, e._child.id).then((res) => {
      // this.$api.INFO(19,18).then((res) => {
        // console.log("tabs",res);
        this.$store.commit("setMenu", e);
      // });
    },
  },
};
</script>
<style scoped lang='less'>
.select {
  position: absolute;
  top: 3.645vw;
  width:  8.3vw;
  border: none;
  text-align: center;
  background: #fff;
  > li {
    cursor: pointer;
    height: 3.645vw;
    line-height: 3.645vw;
  }
  > li:hover {
    color: #1680d9;
  }
}
.content {
  width: 100vw;
  background: #eaf7ff;
  > div {
    position: relative;
    width: 77.7vw;
    margin: 0 auto;
    .ul_bar {
      height: 3.645vw;
      display: flex;
      align-items: center;
      > li {
        font-size:1vw;
        text-align: center;
        width:  8.3vw;
        height: 100%;
        line-height: 3.645vw;
      }
      li:hover {
        cursor: pointer;
        color: "#fff";
        background: "#1680d9";
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabsCenter.vue